<template>
  <section>
    <header class="steps">
      <ul :class="'list-' + steps.length">
        <li
          v-for="(step, index) in steps"
          :key="step.name"
          :class="{ active: index === currentStep, final: index < currentStep }"
        >
          <span class="bullet"><b v-if="index === currentStep">&bull;</b></span>
          <span class="step-name">{{ step.name }}</span>
        </li>
      </ul>
    </header>
  </section>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.steps {
  background-color: var(--bg-color-primary);
  border-radius: $border-radius;

  height: 5.625rem;
  margin-top: 0.9375rem;
  overflow: hidden;
  position: relative;
  ul {
    display: flex;
    justify-content: space-between;
    padding: 0.9375rem 0;
    position: relative;
    &:after {
      content: '';
      width: 75%;
      height: 0.1rem;
      display: block;
      position: absolute;

      background-color: var(--neutral-color-4);
      right: 0;
      left: 2%;
      margin: 0 auto;
      z-index: 0;
      top: 2rem;
    }
    li {
      text-align: center;

      color: var(--gray-700);
      z-index: 1;
      min-width: 25%;
      max-width: 50%;
      span.bullet {
        content: '';
        top: 0.2rem;
        margin: 0 auto 0.75rem;
        display: block;
        border-radius: 100%;
        height: 1.5625rem;
        width: 1.5625rem;

        background-color: var(--white);
        box-shadow: 0 1px 4px 0 $gray-400;
        box-shadow: 0 1px 4px 0 $gray-400;
        position: relative;
      }
      span.name {
        position: relative;
      }
      &.active {
        span.bullet {
          color: var(--primary);
          line-height: 0.55;
          font-size: 3rem;
          text-align: center;
        }
      }
      &.final {
        span.bullet {
          content: '';

          background: var(--primary)
            url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'><path style='fill:rgb(255, 2555, 255)' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'></path></svg>");

          color: var(--white);
          background-size: 70%;
          background-repeat: no-repeat;
          background-position: center;
        }
        &:after {
          content: '';
          width: 300%;
          height: 0.1rem;
          display: block;
          position: relative;

          background-color: var(--primary);
          right: 0;
          left: 50%;
          margin: 0 auto;
          z-index: -1;
          top: -2.4rem;
        }
      }
      &:last-child:after {
        display: none;
      }
    }
  }
  .list-3 {
    .final:after {
      width: 150%;
    }
  }
  .list-4 {
    .final:after {
      width: 100%;
    }
  }
}
@media (max-width: 48rem) {
  .steps {
    ul {
      padding: 0;
      &:after {
        top: 2rem;
      }
      li span.bullet {
        top: 1rem;
      }
    }
    li:not(.active) {
      .step-name {
        display: none;
      }
    }
    li.final {
      top: 2rem;
    }
    li.active {
      .step-name {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-weight: $font-bold;

        bottom: -2rem;
      }
    }
  }
}
</style>
